<mat-card class="example-card fadeInDown">
    <mat-card-header>
        <img src="../../assets/img/logo.png" class="round fadeIn first">
    </mat-card-header>
    <mat-card-content>
            <form class="example-form fadeIn second">
                    <mat-form-field class="example-full-width">
                      <input matInput placeholder="Email" [formControl]="emailFormControl" appLowercaseInput
                              >
                      <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
                        Please enter a valid email address
                      </mat-error>
                      <mat-error *ngIf="emailFormControl.hasError('required')">
                        Email is <strong>required</strong>
                      </mat-error>
                    </mat-form-field>
                          <button type="submit" class="full fadeIn third" (click)="forgetpassword()" mat-raised-button color="primary" [disabled]="!emailFormControl.valid">Rest password</button>
                  </form>
                  <mat-divider></mat-divider>
                  <button type="button" class="full fadeIn fourth" mat-button color="primary" [routerLink]="['/login']" >Login</button>

    </mat-card-content>

  </mat-card>




